import { rem } from 'polished';
import React, { memo } from 'react';
import styled from 'styled-components';
import { border, borderRadius, height, width } from 'styled-system';
import Box from '../Box';
const StyledSuffix = styled(Box).withConfig({
  displayName: "Suffix__StyledSuffix",
  componentId: "sc-iv461i-0"
})(["", " ", " ", " ", " white-space:nowrap;border-left:none;border-top-left-radius:0;border-bottom-left-radius:0;"], border, borderRadius, height, width);
const Suffix = /*#__PURE__*/memo(props => /*#__PURE__*/React.createElement(StyledSuffix, props));
Suffix.propTypes = {
  ...Box.propTypes,
  ...borderRadius.propTypes,
  ...height.propTypes
};
Suffix.defaultProps = {
  as: 'span',
  display: 'block',
  height: rem(40),
  py: 2,
  px: 3,
  bg: 'gray.1',
  border: 'default',
  borderRadius: 'corner'
};
Suffix.displayName = 'Suffix';
export default Suffix;